import { GeneralPackageModuleApi } from './../api/general-package.api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneralPackageModuleData } from '../interface/general-package';

@Injectable()
export class GeneralPackageModuleService extends GeneralPackageModuleData  {

  constructor(private api:  GeneralPackageModuleApi) {
    super();
  }

  list(url: string): Observable< any[]> {
    return this.api.list(url);
  }
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

  getById(url:string): Observable< any>{
      return this.api.getById(url);
  }

  create(url: string, data: any): Observable< any> {
    return this.api.create(url,data);
  }

  update(url: string, data: any): Observable< any> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

}
